import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const CHAT_KEY = 'app::main::chat';
export type ChatState = {
    trial: boolean;
    internalTestMode: boolean;
    lobbyChatEnable: boolean;
    HideMessage: boolean;
};

const initialChatState = {} as ChatState;
const updateData = (
    state: ChatState,
    action: PayloadAction<{
        trial: boolean;
        internalTestMode: boolean;
        lobbyChatEnable: boolean;
        HideMessage: boolean;
    }>
) => {
    state.trial = action.payload.trial;
    state.internalTestMode = action.payload.internalTestMode;
    state.lobbyChatEnable = action.payload.lobbyChatEnable;
    state.HideMessage = action.payload.HideMessage;
};

const chatSlice = createSlice({
    name: CHAT_KEY,
    initialState: initialChatState,
    reducers: {
        updateData,
    },
});
export const chatSliceReducer = chatSlice.reducer;
export const chatSliceActions = chatSlice.actions;
